import { Theme } from '@mui/material';

export const getSectionStyles = (theme: Theme) => ({
  paper: {
    padding: 0,
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    backgroundColor: theme.palette.action.hover,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  content: {
    padding: '16px',
  },
});

export const getRecipientStyles = (theme: Theme) => ({
  item: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '12px',
    borderRadius: '8px',
    backgroundColor: theme.palette.action.hover,
    border: '1px solid transparent',
    transition: 'background-color 0.15s ease, border-color 0.15s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
  },
  itemSelected: {
    backgroundColor: theme.palette.mode === 'dark'
      ? 'rgba(76, 175, 80, 0.08)'
      : 'rgba(76, 175, 80, 0.12)',
    borderColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: theme.palette.mode === 'dark'
        ? 'rgba(76, 175, 80, 0.12)'
        : 'rgba(76, 175, 80, 0.16)',
    },
  },
  info: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '6px',
    minWidth: 0,
  },
  nameRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap' as const,
  },
  contactRow: {
    display: 'flex',
    flexWrap: 'wrap' as const,
    gap: '8px',
    paddingLeft: '4px',
  },
  contactChip: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '2px 8px',
    backgroundColor: theme.palette.action.selected,
    borderRadius: '12px',
    fontSize: '0.75rem',
    '& svg': {
      fontSize: '14px',
      opacity: 0.7,
    },
  },
  addForm: {
    padding: '16px',
    marginTop: '8px',
    backgroundColor: theme.palette.action.hover,
    borderRadius: '8px',
    border: `1px dashed ${theme.palette.divider}`,
  },
  addActions: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
    marginTop: '8px',
  },
});

export const getAttachmentStyles = (theme: Theme) => ({
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    backgroundColor: theme.palette.action.hover,
    borderRadius: '8px',
    border: `1px solid ${theme.palette.divider}`,
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
  },
});
